// Default store links for the mobile apps recommended by the DTI tool. They replace the AppsFlyer
// OneLink URLs, which stopped working when AppsFlyer was decommissioned. Contentful can override
// them through dtiRecommendationProps (goodAppStoreLink, goodGooglePlayLink, moloAppStoreLink,
// moloGooglePlayLink).
export const GOOD_APP_LINKS = {
  appStore: 'https://apps.apple.com/us/app/achieve-good-get-out-of-debt/id1613574429',
  googlePlay: 'https://play.google.com/store/apps/details?id=com.achieve.good',
}

export const MOLO_APP_LINKS = {
  appStore: 'https://apps.apple.com/us/app/achieve-molo-money-left-over/id1645182043',
  googlePlay: 'https://play.google.com/store/apps/details?id=com.achieve.molo.production',
}
